module.exports = __webpack_public_path__ + "img/NearCode.ad9f2f0d.png";